export class PobierzSparowaneSrodkiRekorduEwidencjiModel {
    idRekordu: string;
    idProjektu: string;
}